<template>
  <n-config-provider :theme="darkTheme" :theme-overrides="themeOverrides" :rtl="rtl" :locale="faIR" :date-locale="dateFaIR">
    <n-message-provider placement="top">
      <n-dialog-provider>
        <router-view />
      </n-dialog-provider>
    </n-message-provider>
  </n-config-provider>
</template>

<script setup lang="ts">
import { dateFaIR, faIR, NConfigProvider, NDialogProvider, NMessageProvider } from 'naive-ui';
import { darkTheme, rtl, themeOverrides } from './theme';
</script>
